var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect } from "react";
import { CATEGORIAS_POR_SISTEMA, SISTEMA_OPTIONS } from "../schema";
import { FormSelect } from "./ui/FormSelect";
import { FormTextarea } from "./ui/FormTextarea";
export function OccurrenceSection(_a) {
    var _b, _c, _d;
    var form = _a.form, charCount = _a.charCount;
    var register = form.register, errors = form.formState.errors, watch = form.watch, setValue = form.setValue;
    var sistemaValue = watch("sistema");
    var categoriasDisponiveis = sistemaValue
        ? CATEGORIAS_POR_SISTEMA[sistemaValue] || []
        : [];
    // Limpar categoria quando sistema mudar
    useEffect(function () {
        if (sistemaValue) {
            setValue("categoria", "");
        }
    }, [sistemaValue, setValue]);
    return (_jsxs("section", __assign({ className: "space-y-4" }, { children: [_jsx("h2", __assign({ className: "text-lg font-semibold text-[#0f4098]" }, { children: "Dados da ocorr\u00EAncia" })), _jsxs("div", __assign({ className: "grid grid-cols-1 md:grid-cols-2 gap-4" }, { children: [_jsx("div", __assign({ className: "space-y-1" }, { children: _jsx(FormSelect, { label: "Sistema", options: SISTEMA_OPTIONS.map(function (s) { return ({
                                value: s.value,
                                label: s.label,
                            }); }), registration: register("sistema"), error: (_b = errors.sistema) === null || _b === void 0 ? void 0 : _b.message }) })), _jsx("div", __assign({ className: "space-y-1" }, { children: _jsx(FormSelect, { label: "Categoria", options: categoriasDisponiveis.map(function (c) { return ({
                                value: c.value,
                                label: c.label,
                            }); }), registration: register("categoria"), error: (_c = errors.categoria) === null || _c === void 0 ? void 0 : _c.message, disabled: !sistemaValue || categoriasDisponiveis.length === 0 }) }))] })), _jsx("div", __assign({ className: "space-y-1" }, { children: _jsx(FormTextarea, { label: "Descri\u00E7\u00E3o da ocorr\u00EAncia", placeholder: "Digite aqui...", registration: register("description"), error: (_d = errors.description) === null || _d === void 0 ? void 0 : _d.message, currentLength: charCount, maxLength: 4000, rows: 5 }) }))] })));
}
